(function () {
  'use strict';

  var COLOR_MAP = {
    'Shiny Pink':    '#F1C9C9',
    'Soft Black':    '#303538',
    'Soft Espresso': '#514242',
    'Sky Blue':      '#B9D9EA',
    'Lavender':      '#D6C7E8',
  };

  var allVariants = [], swatchData = [], selectedIds = [], activeQty = 1, interceptAttached = false;
  var ITEM_LABEL = 'Brush';
  var GRATIS_LABEL = '';
  var SEL_BUNDLE_WRAP  = '.bundle-options';
  var SEL_BUNDLE_INPUT = '.bundle-option__input';
  var SEL_VISUAL_BTN   = '.visual-option-btn';
  var SEL_PRODUCT_FORM = 'form[id*="product-form"]';
  var SEL_BC_WRAP      = '.bc-wrap';

  function boot() {
    var bundleWrap = document.querySelector(SEL_BUNDLE_WRAP);
    if (!bundleWrap) return;
    ITEM_LABEL = bundleWrap.dataset.multiColorItemLabel || ITEM_LABEL;
    GRATIS_LABEL = bundleWrap.dataset.gratisLabel || '';
    loadVariants();
    buildSwatchData();
    if (!swatchData.length) return;
    document.addEventListener('change', onBundleChange);
    document.addEventListener('click',  onTopSwatchClick);
    attachCartIntercept();
    injectCSS();
    var checked = document.querySelector(SEL_BUNDLE_INPUT + ':checked');
    if (checked) {
      activeQty = parseInt(checked.dataset.quantity, 10) || 1;
      if (activeQty > 1) renderSelectors(activeQty, checked);
    }
  }

  function loadVariants() {
    var el = document.querySelector('script.variant-data');
    if (el) { try { allVariants = JSON.parse(el.textContent); } catch (_) {} }
  }

  function buildSwatchData() {
    var seen = {};
    document.querySelectorAll(SEL_VISUAL_BTN).forEach(function (btn) {
      var value = btn.dataset.value;
      if (!value || seen[value]) return;
      seen[value] = true;
      var available = btn.dataset.available !== 'false';
      var variant = allVariants.find(function (v) { return v.option1 === value || v.title === value; });
      swatchData.push({
        value: value,
        color: COLOR_MAP[value] || '#cccccc',
        available: variant ? variant.available : available,
        variantId: variant ? variant.id : null,
      });
    });
  }

  function currentTopColor() {
    var active = document.querySelector(SEL_VISUAL_BTN + '.active');
    return active ? active.dataset.value : (swatchData[0] ? swatchData[0].value : '');
  }

  function variantByColor(colorName) {
    var match = swatchData.find(function (c) { return c.value === colorName; });
    return match ? match.variantId : null;
  }

  function onBundleChange(e) {
    if (!e.target.matches(SEL_BUNDLE_INPUT)) return;
    activeQty = parseInt(e.target.dataset.quantity, 10) || 1;
    destroySelectors();
    if (activeQty > 1) renderSelectors(activeQty, e.target);
  }

  function onTopSwatchClick(e) {
    var btn = e.target.closest(SEL_VISUAL_BTN);
    if (!btn || btn.closest(SEL_BC_WRAP)) return;
    if (activeQty <= 1) return;
    setTimeout(syncSlotsToTopColor, 0);
  }

  function syncSlotsToTopColor() {
    var color = currentTopColor();
    selectedIds = selectedIds.map(function () { return variantByColor(color); });
    document.querySelectorAll('.bc-row').forEach(function (row) {
      var nameEl = row.querySelector('.bc-label__color');
      if (nameEl) nameEl.textContent = color;
      row.querySelectorAll('.bc-swatch').forEach(function (s) {
        s.classList.toggle('bc-swatch--active', s.dataset.value === color);
      });
    });
  }

  function renderSelectors(qty, radioInput) {
    destroySelectors();
    var color = currentTopColor();
    var vid = variantByColor(color);
    selectedIds = [];
    for (var i = 0; i < qty; i++) selectedIds.push(vid);
    var optionDiv = radioInput.closest('.bundle-option');
    // Free-gift bundles (e.g. "3 for 2") mark the last slot as the free item —
    // only when the gratis_label metafield is filled in (it supplies the badge text).
    var hasGift = !!(optionDiv && optionDiv.querySelector('.bundle-option__gift-section') && GRATIS_LABEL);
    var wrap = document.createElement('div');
    wrap.className = 'bc-wrap';
    for (var j = 0; j < qty; j++) { wrap.appendChild(buildRow(j, color, hasGift && j === qty - 1)); }
    var target = optionDiv && optionDiv.querySelector('.bundle-option__content');
    if (target) { target.appendChild(wrap); }
    else { document.querySelector(SEL_BUNDLE_WRAP).insertAdjacentElement('afterend', wrap); }
  }

  function destroySelectors() {
    var el = document.querySelector(SEL_BC_WRAP);
    if (el) el.remove();
    selectedIds = [];
  }

  function buildRow(slotIdx, defaultColor, isFreeSlot) {
    var row = document.createElement('div');
    row.className = 'bc-row';
    row.dataset.slot = slotIdx;
    var label = document.createElement('div');
    label.className = 'bc-label';
    var brushSpan = document.createElement('span');
    brushSpan.className = 'bc-label__brush';
    brushSpan.textContent = ITEM_LABEL + ' ' + (slotIdx + 1) + ':';
    var colorSpan = document.createElement('span');
    colorSpan.className = 'bc-label__color';
    colorSpan.textContent = ' ' + defaultColor;
    label.appendChild(brushSpan);
    label.appendChild(colorSpan);
    if (isFreeSlot) {
      var freeBadge = document.createElement('span');
      freeBadge.className = 'bc-label__free';
      freeBadge.textContent = GRATIS_LABEL;
      label.appendChild(freeBadge);
    }
    var swatches = document.createElement('div');
    swatches.className = 'bc-swatches';
    swatchData.forEach(function (opt) {
      var isActive = opt.value === defaultColor;
      var isDisabled = !opt.available;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bc-swatch' + (isActive ? ' bc-swatch--active' : '') + (isDisabled ? ' bc-swatch--disabled' : '');
      btn.dataset.value = opt.value;
      btn.disabled = isDisabled;
      btn.title = opt.value;
      var circle = document.createElement('span');
      circle.className = 'bc-swatch__circle';
      circle.style.backgroundColor = opt.color;
      btn.appendChild(circle);
      if (isDisabled) {
        var slash = document.createElement('span');
        slash.className = 'bc-swatch__slash';
        slash.setAttribute('aria-hidden', 'true');
        btn.appendChild(slash);
      }
      btn.addEventListener('click', function () { onSlotClick(slotIdx, opt, btn); });
      swatches.appendChild(btn);
    });
    row.appendChild(label);
    row.appendChild(swatches);
    return row;
  }

  function onSlotClick(slotIdx, opt, clickedBtn) {
    if (!opt.available) return;
    selectedIds[slotIdx] = opt.variantId;
    var row = document.querySelector('.bc-row[data-slot="' + slotIdx + '"]');
    if (!row) return;
    row.querySelectorAll('.bc-swatch').forEach(function (s) { s.classList.remove('bc-swatch--active'); });
    clickedBtn.classList.add('bc-swatch--active');
    var nameEl = row.querySelector('.bc-label__color');
    if (nameEl) nameEl.textContent = opt.value;
  }

  function attachCartIntercept() {
    if (interceptAttached) return;
    interceptAttached = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="add"], button[type="submit"].add-to-cart');
      if (!btn) return;

      var form = btn.closest(SEL_PRODUCT_FORM);
      if (!form) return;

      if (activeQty <= 1) return;

      var wrap = document.querySelector(SEL_BC_WRAP);
      if (!wrap || getComputedStyle(wrap).display === 'none') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      doCartAdd(form);
    }, true); // capture phase — runs before Minimog's click handler
  }

  function doCartAdd(form) {
    var submitBtn = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
    var origText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '…'; }
    var fallbackId = (swatchData.find(function (c) { return c.available; }) || {}).variantId;
    var items = selectedIds.map(function (id) { return { id: id || fallbackId, quantity: 1 }; }).filter(function (item) { return item.id; });
    if (!items.length) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
    .then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
      return res.json();
    })
    .then(function (data) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
      triggerCartUpdate(data);
    })
    .catch(function (err) {
      console.error('[bundle-multi-color] Cart error:', err.message);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
    });
  }

  function triggerCartUpdate(data) {
    if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
      var lineItem = (data && data.items && data.items[0]) ? data.items[0] : data;
      window.Shopify.onItemAdded(lineItem);
      return;
    }
    if (window.MinimogEvents && typeof window.MinimogEvents.emit === 'function') {
      window.MinimogEvents.emit('ON_ITEM_ADDED', data);
    }
  }

  function injectCSS() {
    if (document.getElementById('bc-multi-color-css')) return;
    var s = document.createElement('style');
    s.id = 'bc-multi-color-css';
    s.textContent =
      '.bc-wrap{display:flex;flex-direction:column;gap:12px;margin-top:14px;margin-left:-32px;width:calc(100% + 32px);}' +
      '.bc-row{display:flex;flex-direction:column;gap:8px;}' +
      '.bc-label{font-size:14px;font-weight:400;color:#2D3748;line-height:1.607;}' +
      '.bc-label__brush{font-weight:700;}' +
      '.bc-label__free{display:inline-flex;align-items:center;justify-content:center;margin-left:6px;padding:2px 8px;border-radius:12px;background:#D62E55;color:#fff;font-size:11px;font-weight:700;line-height:16.5px;text-transform:uppercase;letter-spacing:0.5px;vertical-align:middle;}' +
      '.bc-swatches{display:flex;flex-wrap:wrap;align-items:center;gap:12px;}' +
      '.bc-swatch{position:relative;display:flex;align-items:center;justify-content:center;padding:3px;border:1px solid transparent;border-radius:999px;cursor:pointer;background:transparent;transition:border-color .15s ease;flex-shrink:0;}' +
      '.bc-swatch--active{border-color:#000000;}' +
      '.bc-swatch--disabled{opacity:.5;cursor:not-allowed;}' +
      '.bc-swatch__circle{display:block;width:32px;height:32px;border-radius:9999px;}' +
      '.bc-swatch__slash{position:absolute;inset:3px;border-radius:9999px;pointer-events:none;overflow:hidden;}' +
      '.bc-swatch__slash::before{content:"";position:absolute;inset:0;background:linear-gradient(to bottom right,transparent calc(50% - .75px),#CCC9CA calc(50% - .75px),#CCC9CA calc(50% + .75px),transparent calc(50% + .75px));}';
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
}());
